import { API_BASE_URL } from "../config"

export async function fetchUsers(token: string) {
  const res = await fetch(`${API_BASE_URL}/sysadmin-api/users`, {
    headers: { Authorization: `Token ${token}` },
  })
  if (!res.ok) throw new Error("No se pudieron obtener los usuarios")
  return res.json()
}

export async function createUser(token: string, data: any) {
  const res = await fetch(`${API_BASE_URL}/sysadmin-api/users`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error("Failed to create user")
  return res.json()
}

export async function deleteUser(token: string, userId: number) {
  const res = await fetch(`${API_BASE_URL}/sysadmin-api/users/${userId}`, {
    method: "DELETE",
    headers: { Authorization: `Token ${token}` },
  })
  if (!res.ok) throw new Error("Failed to delete user")
  return res.json()
}

export async function fetchLogs(token: string) {
  const res = await fetch(`${API_BASE_URL}/sysadmin-api/logs`, {
    headers: { Authorization: `Token ${token}` },
  })
  if (!res.ok) throw new Error("No se pudieron obtener los registros (logs)")
  return res.json()
}

export async function fetchDbStatus(token: string) {
  const res = await fetch(`${API_BASE_URL}/sysadmin-api/database/status`, {
    headers: { Authorization: `Token ${token}` },
  })
  if (!res.ok) throw new Error("No se pudo obtener el estado de la base de datos")
  return res.json()
}

export async function triggerDbBackup(token: string) {
  const res = await fetch(`${API_BASE_URL}/sysadmin-api/database/backup`, {
    method: "POST",
    headers: { Authorization: `Token ${token}` },
  })
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || "Failed to trigger backup");
  }
  return res.json()
}
